// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__a_Q5r","description":"styles_description__KztmG","skeleton-animation":"styles_skeleton-animation__MQfRy"};